<template>
	<div class="add-sub container-fluid">
		<div class="row">

			<div class="block highlighted-content">
				<div>
					<p class="text-uppercase setting-name">{{ 'Level' | translate }}</p>
				</div>

				<div class="level-block" :class="{ anzan: isAnzan || isTransition }">
					<select @change="onChangeType" v-model="config.type" class="custom-select level-type">
						<option v-for="type in additionalType" :key="type.value" :value="isFree ? 'elementary' : type.value"
							:disabled="isFree && type.value !== 'elementary'">{{ type.label | translate }}
						</option>
					</select>

					<div v-if="!isAnzan && !isTransition" class="level-number">
						<Select v-model="digitMode" :optionsColumns="digitOptions" />
					</div>

				</div>

				<p class="text-uppercase setting-name">{{ 'Complexity' | translate }}</p>
				<!-- <hr v-show="!isTransition" /> -->
				<div class="complexity-list text-center">
					<div v-for="complex in complexityList" :key="complex" @click="config.places = complex"
						:class="config.places === complex ? 'active' : ''" class="complexity">
						{{ complex }}
					</div>
				</div>


				<!-- <p v-if="!isAnzan && !isTransition" class="text-uppercase setting-name">{{ 'Числа' | translate }}</p> -->

				<!-- <select v-if="!isAnzan" v-show="!isTransition" v-model="config.digit" class="custom-select mb-2 mr-sm-2 mb-sm-0">
					<option v-for="digit in digits" :key="digit" :value="digit">{{ digit }}
					</option>
				</select> -->

				<!-- <fieldset v-if="!isAnzan" v-show="!isTransition" class="digits-field">
					<div>
						<div v-for="digit in digits" :key="digit">
							<label :value="digit">
								<input type="radio" name="digits" :value="digit" :key="digit" :id="digit"
									@change="changeDigit(digit, false)" :checked="digit == activeCheckbox" />
								{{ digit }}
							</label>
						</div>
					</div>

					<div>
						<div v-for="digit in digitsPro" :key="digit">
							<label :value="digit">
								<input type="radio" name="digits" :value="digit + 'pro'" :key="digit" :id="digit"
									@change="changeDigit(digit, true)" :checked="`${digit}pro` == activeCheckbox" />
								{{ digit }}pro
							</label>
						</div>
					</div>
				</fieldset> -->

				<div v-if="isAnzan">
					<p class="text-uppercase setting-name">{{ 'Anzan' | translate }} type</p>
				</div>

				<div v-if="isAnzan">
					<div>
						<fieldset class="digits-field anzan">
							<div>
								<div class="form-check">
									<label class="form-check-label">
										<input type="radio" class="form-check-input" value="anzan_random" v-model="config.digit_type" />
										{{ 'Random numbers' | translate }}
									</label>
								</div>

								<div class="form-check">
									<label class="form-check-label">
										<input type="radio" class="form-check-input" value="anzan_plus" v-model="config.digit_type" />
										{{ 'Only add' | translate }}
									</label>
								</div>
								<div class="form-check">
									<label class="form-check-label">
										<input type="radio" class="form-check-input" v-model="config.digit_type" value="anzan_minus" />
										{{ 'Only subtraction' | translate }}
									</label>
								</div>
							</div>

						</fieldset>
					</div>


					<!-- <select required v-model="config.digit_type" class="custom-select">
						<option :value="digit.value" v-for="(digit, index) in anzanType" :key="index">
							{{ $t(digit.label).toLowerCase() }}
						</option>
					</select> -->
				</div>


				<p class="text-uppercase setting-name">{{ 'Speed' | translate }}</p>

				<div class="input-number">
					<button @click="changeSpeed(-0.1)" class="btn btn-blue">-</button>

					<input v-model="config.speed" type="number" />

					<button @click="changeSpeed(0.1)" class="btn btn-blue">+</button>
				</div>

				<div>
					<p class="text-uppercase setting-name">
						{{ 'AMOUNT OF ACTIONS WITH NUMBER' | translate }}
					</p>
					<!-- <hr /> -->
				</div>

				<div class="input-number">
					<button @click="changeLength(-1)" class="btn btn-blue">-</button>

					<input v-model="config.length" @blur="onBlurLength" type="number" min="2" max="25" />

					<button @click="changeLength(1)" class="btn btn-blue">+</button>
				</div>

				<div>
					<p class="text-uppercase setting-name">
						{{ 'Sound' | translate }}/{{ 'Language' | translate }}
					</p>
					<!-- <hr /> -->
				</div>

				<div class="sound-block">
					<div class="sound-control">
						<label>
							<input :disabled="disabledWithSound" v-model="config.withSound" type="checkbox" class="form-check-input" />
							<span class="custom-control-indicator"></span>
							<span class="custom-control-description">{{
								'Sound' | translate
							}}</span>
						</label>
					</div>

					<language-select :value="language" @change="value => (language = value)" className="custom-select" />
				</div>

				<div class="btn-actions">
					<button @click="startGame" class="text-uppercase btn btn-success">
						{{ 'Start' | translate }}
					</button>
					<!-- <div @click="isDemo ? $router.push('/demo') : $router.go(-1)" class="text-uppercase btn btn-pink">
						{{ 'Back' | translate }}
					</div> -->
				</div>
			</div>

		</div>



		<!-- <div class="block" :class="{ 'highlighted-content': isCustomBgEnabled }">
				<div>
					<h6 class="text-uppercase">{{ 'Level' | translate }}</h6>
					<hr />
				</div>

				<select @change="onChangeType" v-model="config.type" class="custom-select mb-2 mr-sm-2 mb-sm-0">
					<option v-for="type in additionalType" :key="type.value" :value="isFree ? 'elementary' : type.value"
						:disabled="isFree && type.value !== 'elementary'">{{ type.label | translate }}
					</option>
				</select>

				<select v-if="!isAnzan" v-show="!isTransition" v-model="config.digit" class="custom-select mb-2 mr-sm-2 mb-sm-0">
					<option v-for="digit in digits" :key="digit" :value="digit">{{ digit }}
					</option>
				</select>

				<div v-else>
					<h6 class="text-uppercase">{{ 'Anzan' | translate }} type</h6>
					<hr />

					<select required v-model="config.digit_type" class="form-control mt-3">
						<option :value="digit.value" v-for="(digit, index) in anzanType" :key="index">
							{{ $t(digit.label).toLowerCase() }}
						</option>
					</select>
				</div>

				<div v-if="!isTransition">
					<div>
						<h6 class="text-uppercase">
							{{ 'AMOUNT OF ACTIONS WITH NUMBER' | translate }}
						</h6>
						<hr />
					</div>

					<div class="input-number">
						<input v-model="config.length" type="number" />
						<button @click="changeLength(-1)" class="btn btn-blue">-</button>
						<button @click="changeLength(1)" class="btn btn-blue">+</button>
					</div>
				</div>

				<div class="btn-actions">
					<button @click="startGame" class="text-uppercase btn btn-success">
						{{ 'Start' | translate }}
					</button>
					<div @click="isDemo ? $router.push('/demo') : $router.go(-1)" class="text-uppercase btn btn-pink">
						{{ 'Back' | translate }}
					</div>
				</div>
			</div> -->

	</div>
</template>

<script>
import {
	getConfig,
	updateConfig,
	LABELED_ADDITION_TYPES,
	LABELED_ADDITION_TYPES_DEMO,
	ADDITION_DIGITS,
	getAdditionalDigits,
	ADDITION_PRO_DIGITS,
	getAdditionalProDigits,
	ANZAN_TYPES,
	DEFAULT_ANZAN_TYPE,
	PLACES,
	ADDITION_DIGITS_DEMO,
} from '../gameConfig'
import { Vue, Component, Watch } from 'vue-property-decorator'
import Checkbox from './Checkbox.vue'
import LanguageSelect from '@/components/LanguageSelect.vue'
import Select from '@/components/UI/Select.vue'

@Component({
	components: {
		Checkbox,
		LanguageSelect,
		Select,
	},
	computed: {
		anzanType() {
			return [
				{ value: 'anzan_random', label: 'Random numbers' },
				{ value: 'anzan_minus', label: 'Only subtraction' },
				{ value: 'anzan_plus', label: 'Only add' },
			]
		},
	},
})
export default class Addition extends Vue {
	config = {
		speed: '',
		length: '',
		places: '',
		type: 'elementary',
		digit_type: DEFAULT_ANZAN_TYPE,
		digit: '3',
		withSound: false,
		pro: false,
	}
	isFree = localStorage.getItem('userProfile')
		? JSON.parse(localStorage.getItem('userProfile'))?.is_free
		: true
	language = ''

	onBlurLength() {
		if (this.config.length < 2) {
			this.config.length = '2'
		}
	}

	changeDigit(digit, isPro) {
		this.config.digit = digit;

		this.config.pro = isPro;
	}

	changeSpeed(val) {
		if (+this.config.speed === 0.1 && val === -0.1) return false
		let newVal = +this.config.speed + val
		this.config.speed = newVal.toFixed(1)
	}

	changeLength(val) {
		if (+this.config.length === 2 && val === -1) return false

		this.config.length = String(Number(this.config.length) + val)
	}

	startGame() {
		if (
			this.config.type === 'addition' ||
			this.config.type === 'abacus_random' ||
			this.config.type === 'anzan'
		) {
			this.config.type = this.config.digit_type
		}
		this.$store.commit('changeGameConfig', this.config)
		this.$router.push({ path: this.isDemo ? '/demo/game' : '/games/game' })
	}

	// Reset digit to default for new type
	onChangeType() {
		this.config.digit = this.config.type == 'elementary' && this.config.digit == 1
			? '3'
			: this.digits[0].toString()
	}

	get digitMode() {
		return `${this.config.digit}${this.config.pro ? 'pro' : ''}`
	}

	set digitMode(newValue) {
		const currentMode = String(newValue)

		console.log(currentMode)
		console.log(parseInt(currentMode), currentMode.includes('pro'))

		this.config.digit = String(parseInt(currentMode))
		this.config.pro = currentMode.includes('pro')
	}

	get activeCheckbox() {
		return `${this.config.digit}${this.config.pro ? 'pro' : ''}`
	}

	get isTransition() {
		return this.config.type.includes('fifty') || this.config.type.includes('hundred')
	}

	get additionalType() {
		return LABELED_ADDITION_TYPES
		// this.isDemo ? LABELED_ADDITION_TYPES_DEMO :
	}

	get isCustomBgEnabled() {
		return !!this.$store.getters.primaryBackground
	}

	get digits() {
		const type = this.config.type
		return this.isDemo
			? ADDITION_DIGITS_DEMO
			: getAdditionalDigits(type, +this.config.places)
	}

	get digitsPro() {
		const type = this.config.type
		return this.isDemo
			? ADDITION_DIGITS_DEMO
			: getAdditionalProDigits(type, +this.config.places)
	}

	get isAnzan() {
		return this.config.type === 'anzan'
	}

	get disabledWithSound() {
		const { places, speed } = this.config
		return (+speed < 1 && +places <= 10) || (+places >= 100 && +speed < 2.5)
	}

	get complexityList() {
		if (this.isTransition) {
			// if (this.config.type.includes('hundred')) {
			// 	return PLACES.filter(i => i !== 1 && i !== 10)
			// }

			return PLACES.filter(i => i !== 1)
		};

		return this.isDemo ? [1] : PLACES;
	}

	get isDemo() {
		return !!this.$route.path.startsWith('/demo')
	}

	get defaultLng() {
		let userDefaultLng = this.$store.state.myProfile?.default_language
		userDefaultLng = (userDefaultLng || '').toLowerCase()
		return !userDefaultLng
			? this.$i18n.locale()
			: userDefaultLng === 'ua'
				? 'uk'
				: userDefaultLng
	}

	get digitOptions() {
		return [[...this.digits], [...this.digitsPro.map(i => `${i}pro`)]]
	}

	@Watch('language')
	onLanguageChanged() {
		updateConfig({ language: () => this.language }, !this.isDemo)
	}

	@Watch('config', { deep: true })
	onConfigChanged(val) {
		updateConfig({ addition: () => val }, !this.isDemo)
	}

	@Watch('config.places')
	onComplexityChanged(val) {
		console.log('complexity changed')

		if (this.config.type == 'elementary' && this.config.digit < 3 && val == 1) {
			console.log('options')

			this.config.digit = '3'
		}
	}

	@Watch('config.places')
	validateDigit() {
		const firstDigit = this.digits[0]
		if (
			this.config.type === 'elementary' &&
			+this.config.places === 1 &&
			firstDigit > +this.config.digit
		) {
			this.config.digit = firstDigit.toString()
		}
	}

	@Watch('config.length')
	validateDigit() {
		if (this.config.length > 25) {
			this.config.length = '25'
		}
	}


	@Watch('config.places')
	@Watch('config.speed')
	validateWithSound() {
		if (this.config.withSound && this.disabledWithSound) {
			this.config.withSound = false
		}
	}

	@Watch('config.type')
	isTransitionDefault() {
		if (this.isTransition && this.config.places == 1) {
			this.config.places = 10
		}
	}

	created() {
		// Setup default values
		const config = getConfig(this.defaultLng, !this.isDemo)
		this.language = config.language
		this.config = config.addition
		if (!this.config.digit_type) this.config.digit_type = DEFAULT_ANZAN_TYPE

		this.digitMode = `${config.addition.digit}${this.config.pro ? 'pro' : ''}`
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
// .block {
// 	display: grid;
// 	grid-template-columns: 40% 60%;
// 	grid-gap: 15px;

// 	width: fit-content;
// 	padding: 30px;
// 	margin: auto;

// 	&.highlighted-content {
// 		background: #fff;
// 		border-radius: 12px;
// 		// border: 2px solid red;
// 		color: #212529;

// 		box-shadow: 0px 15px 30px rgba(20, 35, 62, 0.15);
// 	}

// 	& h6 {
// 		margin: 0;
// 	}

// 	@media (max-width: 767px) {
// 		width: 100% !important;
// 		margin: 10px !important;

// 		display: flex !important;
// 		flex-direction: column !important;
// 		align-items: center !important;
// 		text-align: center !important;
// 	}
// }

// .form-check {
// 	margin-bottom: 20px;
// }

.btn-success {
	height: 45px;
	width: 100px;
	// margin: 10px 15px;
}

.custom-select {
	width: 320px;
	text-transform: uppercase;

	* {
		text-transform: uppercase;
	}

	@media (max-width: 767px) {
		width: 100% !important;
	}
}

.btn-pink {
	background-color: #e4467b;
	color: #fff;
	height: 50px;
	line-height: 2;
	margin: 10px 15px;
	cursor: pointer;
}

.btn-pink:hover {
	background-color: #e85183;
}

.form-inline {
	margin: 0; //20px 0;

	@media (max-width: 767px) {
		display: block;
	}
}

// .btn-actions {
// 	margin-top: 25px;

// 	text-align: center;
// 	grid-column-start: 1;
// 	grid-column-end: 3;
// }

// @media (max-width: 767px) {
// 	.base-list {
// 		text-align: center;
// 	}

// 	.form-inline {
// 		justify-content: center;
// 	}

// 	.form-check {
// 		display: inline-block;
// 		margin: 5px;
// 	}

// 	.check-list {
// 		text-align: center;
// 	}
// }
</style>
